document.addEventListener('DOMContentLoaded', function() {
  // 判断是否是桌面端
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

  document.querySelectorAll('[id^="Details-HeaderMenu-"]').forEach((details) => {
    const summary = details.querySelector('summary');

    // 设置基础 ARIA 属性
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', details.hasAttribute('open'));
    if (summary.nextElementSibling?.id) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    // 绑定键盘关闭逻辑
    if (!summary.closest('header-drawer, menu-drawer')) {
      details.addEventListener('keyup', onKeyUpEscape);
    }

    // 清除原有 click 事件，防止冲突
    summary.addEventListener('click', (e) => {
      if (isDesktop()) {
        e.preventDefault(); // PC端 hover 控制，阻止 click
      } 
      // 移动端保持原生 click
    });

    // PC端 hover 控制展开收起
    if (isDesktop()) {
      details.addEventListener('mouseenter', () => {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', true);
      });

      details.addEventListener('mouseleave', () => {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', false);
      });
    }
  });
});